import { Link, useLocation } from 'react-router-dom';
import { inteiro } from '../lib/formato.js';

export interface Aba {
  para: string;
  rotulo: string;
  contagem?: number;
  critica?: boolean;
}

export function Abas({ abas }: { abas: Aba[] }) {
  const { pathname } = useLocation();

  return (
    <nav className="tabs" role="tablist" aria-label="Seções do Raio-X">
      {abas.map((aba) => {
        const ativa = aba.para === '/' ? pathname === '/' : pathname.startsWith(aba.para);
        return (
          <Link key={aba.para} to={aba.para} role="tab" className="tab" aria-selected={ativa}>
            {aba.rotulo}
            {aba.contagem !== undefined && aba.contagem > 0 ? (
              <span className={`count${aba.critica ? ' crit' : ''}`}>{inteiro(aba.contagem)}</span>
            ) : null}
          </Link>
        );
      })}
    </nav>
  );
}
